import { Button } from 'common/components/Button/Button';
import '../ButtonsWrapper.scss';

export function ButtonsWrapper(props: any) {
  return (
    <div className="ButtonsWrapper">
      <div className="error">{props.error}</div>
      <Button
        buttonStyle="secondary"
        size="small"
        text="Cancel"
        onClick={props.onClose}
        type="button"
        disabled={props.isSubmiting}
      />
      <Button
        buttonStyle="main"
        size="small"
        text="Save"
        onClick={props.onSave}
        type="button"
        loading={props.isSubmiting}
        disabled={!props.isValidated}
      />
    </div>
  );
}
